import { useEffect, useState } from "react";
import MultiView from "../../multiView/MultiView"
import Loader from "../../generic/Loader";
import CardView from "../../cardView/CardView";
import TabView from "./TabView";
import SwitchView from "./SwitchView"
import CompositeView from "./CompositeView"

import { useStore } from "../Page";


// FUnction that returns the filterValue in the filter array based on filterKey and filterValue
const applyFilter = (filterKey, filterValue, filterArray) => {
  const matchedFilter = filterArray.find(f => f.filterValue === filterValue);
  return matchedFilter ? matchedFilter : "empty";
};

const FilteredView = ({ options, dispatch, config }) => {

  const { filter } = config
  const [filtered] = useStore((s) => s[filter.filterKey])

  const [filterApplied, setFilterApplied] = useState(false)
  const [matchedFilter, setMatchedFilter] = useState('empty')

  useEffect(
    () => {
      const result = applyFilter(filter.filterKey, filtered, filter.filterArray)
      setMatchedFilter(result)
      setFilterApplied(true)
    }, [filtered]
  )

  //console.log( '[FilteredView] FilterResult: ', matchedFilter)
  //console.log('Re-rendering Filtered View')
  return (
    <>

      {filterApplied && matchedFilter !== 'empty' && (() => {
        const viewType = matchedFilter.viewType || filter.viewType
        if (viewType === 'multiView')     return <MultiView options={options} type={matchedFilter.filterResult} dispatch={dispatch} />
        if (viewType === 'tabView')       return <TabView type={matchedFilter.filterResult} options={options} />
        if (viewType === 'compositeView') return <CompositeView type={matchedFilter.filterResult} options={options} />
        if (viewType === 'switchView')    return <SwitchView type={matchedFilter.filterResult} options={options} view={matchedFilter.filterView} />
        return <CardView type={matchedFilter.filterResult} options={options} />
      })()}

      {filterApplied && matchedFilter === 'empty' && filter.defaultFilterResult && (() => {
        if (filter.viewType === 'multiView')     return <MultiView options={options} type={filter.defaultFilterResult} dispatch={dispatch} />
        if (filter.viewType === 'tabView')       return <TabView type={filter.defaultFilterResult} options={options} />
        if (filter.viewType === 'compositeView') return <CompositeView type={filter.defaultFilterResult} options={options} />
        return <CardView type={filter.defaultFilterResult} options={options} />
      })()}

      {filterApplied && matchedFilter === 'empty' && !filter.defaultFilterResult && <Loader></Loader>}

    </>
  )
}

export default FilteredView